import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { label: '회사소개', path: '/about' },
    { label: '연혁', path: '/about/history' },
    { label: '제품소개', path: '/products' },
    { label: '제작과정', path: '/process' },
    { label: '현장사진', path: '/gallery' },
    { label: '오시는길', path: '/location' },
  ];

  const processLinks = [
    { name: 'STS패널형 물탱크', url: '/process/sts-panel' },
    { name: 'STS원통형 물탱크', url: '/process/sts-cylinder' },
    { name: '라이닝 물탱크', url: '/process/lining' },
  ];

  return (
    <footer className="relative bg-gradient-to-br from-teal-50 to-emerald-50 text-gray-800 pt-20 pb-8">
      <div className="max-w-[1600px] mx-auto px-4 lg:px-6">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img
                src="https://static.readdy.ai/image/75975fdd6a8419c14194c00fe1023b5f/06580d5e232d5cb0cebd682b84a80f70.png"
                alt="삼원테크 로고"
                className="w-10 h-10 object-contain"
              />
              <h3 className="text-2xl font-bold text-gray-900">삼원테크</h3>
            </div>
            <p className="text-gray-600 leading-relaxed mb-6">
              30년 전통의 물탱크 전문 제조업체<br />
              최고의 품질과 기술력으로<br />
              안전한 물 저장 솔루션을 제공합니다
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold text-gray-900 mb-6">빠른 링크</h4>
            <ul className="space-y-3">
              <li>
                <a href="/products" className="text-gray-600 hover:text-teal-600 transition-colors duration-300 cursor-pointer">
                  제품소개
                </a>
              </li>
              <li>
                <a href="/process" className="text-gray-600 hover:text-teal-600 transition-colors duration-300 cursor-pointer">
                  제작공정
                </a>
              </li>
              <li>
                <a href="/gallery" className="text-gray-600 hover:text-teal-600 transition-colors duration-300 cursor-pointer">
                  시공갤러리
                </a>
              </li>
              <li>
                <a href="/location" className="text-gray-600 hover:text-teal-600 transition-colors duration-300 cursor-pointer">
                  오시는길
                </a>
              </li>
            </ul>
          </div>

          {/* Products */}
          <div>
            <h4 className="text-lg font-bold text-gray-900 mb-6">제품</h4>
            <ul className="space-y-3">
              <li>
                <a href="/process/sts-panel" className="text-gray-600 hover:text-teal-600 transition-colors duration-300 cursor-pointer">
                  STS 패널형 물탱크
                </a>
              </li>
              <li>
                <a href="/process/sts-cylinder" className="text-gray-600 hover:text-teal-600 transition-colors duration-300 cursor-pointer">
                  STS 원통형 물탱크
                </a>
              </li>
              <li>
                <a href="/process/lining" className="text-gray-600 hover:text-teal-600 transition-colors duration-300 cursor-pointer">
                  라이닝 물탱크
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold text-gray-900 mb-6">연락처</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-phone-line text-xl text-teal-600 mt-1"></i>
                <div>
                  <p className="text-sm text-gray-500 mb-1">전화</p>
                  <a href="tel:061-373-3221" className="text-gray-800 font-medium hover:text-teal-600 transition-colors cursor-pointer">
                    061-373-3221
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-xl text-teal-600 mt-1"></i>
                <div>
                  <p className="text-sm text-gray-500 mb-1">이메일</p>
                  <a href="mailto:samwontk@hanmail.net" className="text-gray-800 font-medium hover:text-teal-600 transition-colors cursor-pointer">
                    samwontk@hanmail.net
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-xl text-teal-600 mt-1"></i>
                <div>
                  <p className="text-sm text-gray-500 mb-1">주소</p>
                  <p className="text-gray-800 font-medium">
                    전남 화순군 동면 동농공길 26-3
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-300 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-600 text-sm">
              © 2024 삼원테크. All rights reserved.
            </p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-500 text-sm hover:text-teal-600 transition-colors cursor-pointer"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
